module.exports = "<div class=\"panel panel-header\">\n  <p>Score Component</p>\n</div>\n<div class=\"test panel panel-body\">\n  <div id=\"display\">\n    <p>Score: {{displayScore}}</p>\n    <p>Level: {{displayLevel}}</p>\n    <p>Lines: {{displayLines}}</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ColeMarsteller/learn-js/Mehtris/src/app/score/score.component.html
// module id = ../../../../../src/app/score/score.component.html
// module chunks = main